import React from "react";

// perfect scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

import { makeStyles } from "@material-ui/styles";

import { Typography } from "@material-ui/core";

import { translate } from "jazasoft";

import MuiTable from "../../../components/MuiTable";

import ResourceKeys from "../../../utils/ResourceKeys";
import { useDeepMemo, useQuery, useSetting } from "../../../hooks";
import SettingKeys from "../../../utils/SettingKeys";
import { isEmpty } from "../../../utils/helpers";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "#fafafa",
    flex: 1
  },

  accordionDetail: {
    display: "flex",
    flexDirection: "column",
    width: 1080,
    padding: 0
  },
  padding: {
    padding: "1em"
  }
}));

const rColumns = [
  { dataKey: "rollNo", title: "Supplier Roll No" },
  { dataKey: "factoryRollNo", title: "Factory Roll No" },
  { dataKey: "supplierLength", title: "Supplier Length" },
  // { dataKey: "availableLength", title: "Available Length" }
  //   { dataKey: "weight", title: "Weight" },
  //   { dataKey: "gsm", title: "GSM" },
];

const GRNDetails = ({ userActivity, translate }) => {
  const classes = useStyles();

  const resource = ResourceKeys[userActivity?.entityName];

  const { data: childActivityList = [] } = useQuery({
    url: "system-activities",
    params: { search: `parentId==${userActivity?.id}` }
  });

  const rollFields = useSetting(SettingKeys.ENTITY_FIELDS, "rolls");

  const rollColumns = useDeepMemo(() => {
    if (isEmpty(rollFields)) return [];

    let columns = rColumns.map(col => {
      return {
        dataKey: col.dataKey,
        title: translate(`resources.${resource}.fields.${col.dataKey}`, { _: col.title })
      };
    });

    // columns = columns.filter(col => rollFields.includes(col.dataKey));

    return columns;
  }, [rollFields, rColumns]);

  const rows = useDeepMemo(() => {
    if (isEmpty(childActivityList)) return [];
    const rows = childActivityList.map(activity => {
      const roll = activity.operation === "write" ? JSON.parse(activity.currValue || "{}") : JSON.parse(activity.prevValue || "{}");

      return {
        ...roll,
        rollNo: !isEmpty(roll?.rollNo) ? roll?.rollNo : "-",
        factoryRollNo: !isEmpty(roll?.factoryRollNo) ? roll?.factoryRollNo : "-",
        supplierLength: !isEmpty(roll?.supplierLength) ? roll?.supplierLength : "-",
        availableLength: !isEmpty(roll?.availableLength) ? roll?.availableLength : "-"
      };
    });
    return rows;
  }, [childActivityList]);

  return (
    <PerfectScrollbar className={classes.root}>
      <div style={{ padding: 16 }}>
        <Typography style={{ marginBottom: 8, color: "#666666" }} variant="h6">
          GRN Details
        </Typography>
        <div>
          <MuiTable columns={rollColumns} rows={rows} />
        </div>
      </div>
    </PerfectScrollbar>
  );
};

export default translate(GRNDetails);
